import { fetchStrapiApi } from "../../utils/fetchStrapiApi";
import Header from "../../components/header";
import Footer from "../../components/home/footer";
import Link from "next/link";
import rehypeRaw from "rehype-raw";
import DOMPurify from 'isomorphic-dompurify';
import ReactMarkdown from "react-markdown";
import gfm  from "remark-gfm";
import moment from "moment";
import Seo from "@/components/seo";
import { getStrapiMedia } from "../../utils/getStrapiMedia";
import Image from "next/image";

const Article = ({ article, author }) => {
  //console.log(article);
  //console.log(author);

  //console.log(article);
  return (
    <>
      <Seo
        title={`${article.title} | Pinto Financial`}
        description={article.description}
        image={getStrapiMedia(article.image)}
      />

      <Header />

      <div className="relative max-w-7xl mx-auto flex items-center justify-between px-4 sm:px-6 mt-8">
        <div className="py-8 w-full">
          <div className="flex flex-col">
            <div className="">
              <span className="text-gray-300 hover:text-pinto transition duration-300">
                <Link href={`/blog`} passHref>
                  ← View all posts
                </Link>
              </span>
            </div>

            <div className="mt-2 mb-6 overflow-hidden md:rounded-lg">
              {article && article.image && article.image.data &&
              <Image
                width={1300}
                height={500}
                className="w-full"
                src={getStrapiMedia(article.image)}
                alt={article.title}
                unoptimized
              />}
            </div>

            <h1 className="text-4xl font-bold tracking-tight text-gray-800 sm:text-5xl">{article.title}</h1>
            {/*<h5 className="mt-6 text-lg text-gray-600">{article.description}</h5>*/}

            <Link href={`/authors/${author.slug}`} className="flex items-center mt-4">
              <Image width={32} height={32} className="mr-4" src="/avatar.png" alt="Author pic" />
              <div className="flex flex-col items-start">
                <span>{author.name}</span>
                <span className="text-sm text-gray-500">{moment(article.createdAt).format("MMMM d, yyyy")}</span>
              </div>
            </Link>
          </div>

          <div className="mt-8 flex">
            <article className="prose lg:prose-xl">
              <ReactMarkdown rehypePlugins={[rehypeRaw]} remarkPlugins={[gfm]}>
                {/* turned off bc it kills pull quotes TODO later: DOMPurify.sanitize(article.content)*/} 
                {article.content} 
              </ReactMarkdown>
            </article>
          </div>

        </div>
      </div>
      <Footer />
    </>
  );
};

export default Article;

export async function getStaticPaths() {
  const articlesRes = await fetchStrapiApi("/articles", { fields: ["slug"] });

  return {
    paths: articlesRes.data.map((article) => ({
      params: {
        slug: article.attributes.slug,
      },
    })),
    fallback: false,
  };
}

export async function getStaticProps({ params }) {
  const articlesRes = await fetchStrapiApi("/articles", {
    filters: {
      slug: params.slug,
    },
    populate: "*",
  });


  // console.log(articlesRes.data[0].attributes.author.data.id);
  const writersRes = await fetchStrapiApi("/writers", {
    filters: {
      id: articlesRes.data[0].attributes.author.data.id,
    },
    populate: "*",
  });
  //console.log(writersRes.data[0].attributes.picture);

  return {
    props: {
      article: articlesRes.data[0].attributes,
      author: articlesRes.data[0].attributes.author.data.attributes,
    },
    revalidate: 1,
  };
}
